import constants from "./CONSTANTS";

const localStorageLang = localStorage.getItem("lang");

export const initState = {
  lang: localStorageLang ?? "ge",
  additionalTranslations: { en: {}, ge: {} },
  sidebarOpen: true,
  apiCallExecuted: 0,
  moduleLoaded: {},

  // user agreement
  userAgreemet: {},
  userAgreementsGridById: [],
  contractsModalIsOpen: false,
  selectedAgreement: 0,

  notifications: undefined,
  notificationsOpen: false,
  allNotifications: undefined,
  allNotificationsOpen: false,
  websocketIsConnected: false,
  downloadDocumentLoading: true,

  requestDocTitles: [],
};

const reducer = (state = initState, action) => {
  switch (action.type) {
    case constants.SET_LANGUAGE:
      return {
        ...state,
        lang: action.lang,
      };
    case constants.SET_SIDEBAR_OPEN:
      return {
        ...state,
        sidebarOpen: action.status,
      };
    case constants.TOGGLE_SIDEBAR_OPEN:
      return {
        ...state,
        sidebarOpen: !state.sidebarOpen,
      };
    case constants.RESET_COMMON:
      return {
        ...initState,
      };
    case constants.SET_API_CALL_EXECUTED:
      return {
        ...state,
        apiCallExecuted: !state.apiCallExecuted,
      };
    case constants.ADD_ADDITIONAL_TRANSLATIONS:
      return {
        ...state,
        additionalTranslations: {
          en: {
            ...state.additionalTranslations.en,
            ...action.payload.en,
          },
          ge: {
            ...state.additionalTranslations.ge,
            ...action.payload.ge,
          },
        },
      };
    case constants.MODULE_LOADED:
      return {
        ...state,
        moduleLoaded: {
          ...state.moduleLoaded,
          [action.payload]: true,
        },
      };

    // user agreement
    case constants.SET_USER_AGREEMENT:
      return {
        ...state,
        userAgreemet: action.payload,
      };
    case constants.SET_USER_AGREEMENT_BY_ID:
      return {
        ...state,
        userAgreementsGridById: action.payload,
      };
    case constants.SET_CONTRACTS_MODAL_IS_OPEN:
      return {
        ...state,
        contractsModalIsOpen: action.payload,
      };

    case constants.SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
      };
    case constants.SET_NOTIFICATIONS_OPEN:
      return {
        ...state,
        notificationsOpen: action.payload,
      };
    case constants.SET_ALL_NOTIFICATIONS:
      return {
        ...state,
        allNotifications: action.payload,
      };
    case constants.SET_ALL_NOTIFICATIONS_OPEN:
      return {
        ...state,
        allNotificationsOpen: action.payload,
      };
    case constants.SET_WEBSOCKET_CONNECTED:
      return {
        ...state,
        websocketIsConnected: action.payload,
      };
    case constants.SET_DOWNLOAD_DOCUMENT_LOADING:
      return {
        ...state,
        downloadDocumentLoading: action.payload,
      };
    case constants.SET_LEGAL_INFO_DOC_TITLES:
      return {
        ...state,
        requestDocTitles: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
